import { ConfirmModal } from 'components/modal/ConfirmModal';
import CommonSelect from 'components/select/CustomSelect';
import { CustomTable } from 'components/table/style';
import { iconSort } from 'components/table/utlil';
import { Row, Table, TextInput, closeModal, updateQueryStateTable } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';

import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';

import { TABLE_KEY } from 'constants/table';

import { getFullTimeColumns } from '../core/columns';
import { useFullTimeController } from '../core/controller/full-time';

export const FullTimePage = () => {
  const {
    isBiologicAdmin,
    trainers,
    total,
    queryState,
    searchValue,
    onClickRow,
    onClickAction,
    onSubmitDeleteTrainer,
    onChangeSearchValue,
    institutionValue,
    institutions,
    onChangeInstitution,
    searchSelect,
    onChangeSearchInstitution,
  } = useFullTimeController();
  const columns = getFullTimeColumns(isBiologicAdmin, onClickAction, institutionValue.value);

  if (!queryState) {
    return null;
  }

  return (
    <Row direction="column" className="full-width">
      <div
        className="full-width"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: 16,
        }}
      >
        <TextInput
          value={searchValue.value}
          placeholder="Search by name, phone"
          onChange={onChangeSearchValue}
          inputStyle={{
            backgroundColor: 'transparent',
            width: '40%',
          }}
          prefix={<SearchIcon />}
        />
        {isBiologicAdmin && (
          <CommonSelect
            isBorderInput
            value={institutions.find((el: any) => el.value === institutionValue.value)}
            options={institutions.filter((item: any) =>
              item.label.toLowerCase().includes(searchSelect.value.toLowerCase()),
            )}
            onChange={onChangeInstitution}
            onInputChange={onChangeSearchInstitution}
            controlStyle={{ width: 280 }}
            extraStyle={{
              container: (styles) => ({
                ...styles,
                width: 'auto',
              }),
            }}
          />
        )}
      </div>

      <CustomTable>
        <Table
          columns={columns}
          dataSource={trainers}
          total={total.value}
          tableKey={TABLE_KEY.TRAINER_FULL_TIME}
          queryState={{
            ...queryState,
            orderBy:
              queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                ? 'name'
                : queryState.orderBy,
            orderDirection:
              queryState.orderBy === 'createdAt' && queryState.orderDirection === 'DESC'
                ? 'ASC'
                : queryState.orderDirection,
          }}
          updateQueryState={updateQueryStateTable}
          onClickRow={onClickRow}
          headerConfigs={{
            iconSort,
          }}
        />
      </CustomTable>
      <ConfirmModal
        modalKey={MODAL_KEY.DELETE_TRAINER}
        content={'All the stored data of this trainer will be deleted. This action can not undo.'}
        header={`Delete trainer`}
        onCancel={() => closeModal(MODAL_KEY.DELETE_TRAINER)}
        onSubmit={onSubmitDeleteTrainer}
      />
    </Row>
  );
};
